import { Notification } from 'element-ui';
import smoothScroll from '@/modules/animations/smoothScroll';
import errorMessages from '@/modules/form/utils/errorMessages';

export default {
    computed: {
        computedSubmitButtonLabel() {
            return this.isProcessing
                ? 'Please wait...'
                : this.submitButtonLabel
        },

        isProcessing() {
            return this.form.isProcessing;
        }
    },

    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        validationError(error) {
            return ! _.isEmpty(_.get(error, 'errors'));
        },

        paymentError(error) {
            return error.code === 402
        },

        formFailure(data, formName = 'elForm') {
            if (this.validationError(data)) {
                this.formValidationFailed(data.errors)
            } else if (this.paymentError(data)) {
                return this.$msgbox({
                    message: data.message,
                    type: 'error',
                    title: 'Payment Gateway Failure',
                    confirmButtonText: 'Try again',
                });
            } else {
                const error = this.getError(data.message);

                return this.$msgbox({
                    message: error.message,
                    type: 'error',
                    title: error.title || 'Process failure',
                    confirmButtonText: 'OK',
                    dangerouslyUseHTMLString: true
                });
            }
        },

        getError(error, fallbackMessage) {
            return errorMessages.translate(error, fallbackMessage);
        },

        formValidationFailed(errors, formName = 'elForm') {
            _.each(this.$refs[formName].fields, field => {
                const prop = field.$options.propsData.prop;
                const error = errors[prop];

                if (error) {
                    if (prop === 'email' && (error === 'The email has already been taken.' || error[0] === 'The email has already been taken.')) {
                        field.validateMessage = 'Please use an alternative email address';
                        this.$msgbox({
                            message: 'The email address you have entered is linked to an existing (lapsed or active) user profile. Please use an alternative email address to register a new account, or contact us for further assistance.',
                            type: 'error',
                            title: 'Please use an alternative email address',
                            confirmButtonText: 'Close',
                        });
                    } else {
                        field.validateMessage = error[0] || 'This field is invalid';
                    }

                    field.validateState = 'error';
                }
            });

            this.scrollToError(formName);
        },

        notifyGeneralError(error, duration = 0, fallbackMessage) {
            const { message, title } = this.getError(error, fallbackMessage);
            Notification.error({
                title: title,
                message: message,
                duration,
                customClass: 'is-error',
                dangerouslyUseHTMLString: true
            })
        },

        // Stripe explains card errors we have no copy for better than the generic message
        notifyCardError(error) {
            this.notifyGeneralError(error.code, 0, _.escape(error.message));
        },

        scrollToError(formName) {
            const firstError = _.find(this.$refs[formName].fields, field => field.validateState === 'error');

            firstError && smoothScroll.to(firstError.$el, .5, 50);
        },
    },
}
